import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base-api.service';
import { Account } from '../models/account.model';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseApiService<Account> {
  private readonly collection = 'accounts';
  constructor(http: HttpClient) { super(http); }

  getAll() { return this.getAllRaw(this.collection); }
  getById(id: string) { return this.getByIdRaw(this.collection, id); }
  create(item: Account) { return this.createRaw(this.collection, item); }
  update(id: string, item: Partial<Account>) { return this.updateRaw(this.collection, id, item); }
  delete(id: string) { return this.deleteRaw(this.collection, id); }
}